export default class CarouselToggles {

    constructor() {
        this.addEvents();
    }

    addEvents() {
        $( document ).ready(function() {
            $('.carousel-toggles__tab').on('click', function (e){
                e.preventDefault();
                $('.carousel-toggles__tab, .carousel-toggles__item').removeClass('active');
                $(this).addClass('active');
                $('.carousel-toggles__item:nth-child('+($(this).index() + 1)+')').addClass('active');
            })

            $('.carousel-toggles__nav.next').on('click', function (e){
                e.preventDefault();
                let index = $('.carousel-toggles__tab.active').index() + 2 > $('.carousel-toggles__tab').length ? 1 : $('.carousel-toggles__tab.active').index() + 2;
                toSlide(index);
            })

            $('.carousel-toggles__nav.prev').on('click', function (e){
                e.preventDefault();
                let index = $('.carousel-toggles__tab.active').index() == 0 ? $('.carousel-toggles__tab').length : $('.carousel-toggles__tab.active').index();
                toSlide(index);
            })

            function toSlide(index){
                $('.carousel-toggles__tab, .carousel-toggles__item').removeClass('active');
                $('.carousel-toggles__item:nth-child('+index+')').addClass('active');
                $('.carousel-toggles__tab:nth-child('+index+')').addClass('active');
                if($(window).width() <= 799 ){
                    $( ".carousel-toggles__tab:first-child" ).attr('style', 'margin-left: ' + (-(index - 1) * 100 + '%'));
                }
            }
        })
    }

}